import { DateInput, InputProps } from 'react-admin';

interface DateRangeFilterInputProps extends InputProps {
  fullWidth?: boolean,
}

const DateRangeFilterInput = ({ source }: DateRangeFilterInputProps) => {
  return (
    <>
      <DateInput source={`${source}.ge`} />
      <DateInput source={`${source}.le`} />
    </>
  );
};
export default DateRangeFilterInput;
